import getServerSidePropsFactory from '@haaretz/s-pp-get-server-side-props';

import PpDonationPage, { donationUrl } from './PpDonationPage.page';

import type { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = getServerSidePropsFactory('supportHaaretz');

export { donationUrl };
export default PpDonationPage;
